/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Table_TypeInputs */

const en_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const fr_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const it_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const es_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const zh_cn2_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const ja_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const hi_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const pt_pt2_tags_manager_table_type = /** @type {(inputs: Tags_Manager_Table_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Tags_Manager_Table_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_table_type = /** @type {((inputs?: Tags_Manager_Table_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Table_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_table_type(inputs)
	if (locale === "de") return de_tags_manager_table_type(inputs)
	if (locale === "it") return it_tags_manager_table_type(inputs)
	if (locale === "ru") return ru_tags_manager_table_type(inputs)
	if (locale === "es") return es_tags_manager_table_type(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_table_type(inputs)
	if (locale === "ja") return ja_tags_manager_table_type(inputs)
	if (locale === "hi") return hi_tags_manager_table_type(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_table_type(inputs)
	return en_tags_manager_table_type(inputs)
});